module.exports = __webpack_public_path__ + "img/connector-types-desktop-fr.a2467b8e.webp";